import { Inline } from '@/design-system/inline/inline';
import { Stack } from '@/design-system/stack/stack';
import { DataTableNew } from '@seapoint/client/src/design-system/data-table-new';
import { BeneficiaryType } from '@seapoint/server/enums';
import { getCoreRowModel, getPaginationRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { FormState } from 'react-hook-form';
import { PayrollFormData } from '../../financial-information-step/financial-information-form';
import { PayrollEmployee, payrollDraftTableColumnDefinition } from './payroll-draft-table-column-definition';

const PAGE_SIZE = 20;

type PayrollDraftTableProps = {
  employees: PayrollEmployee[];
  selectedRowIds: string[];
  formState: FormState<PayrollFormData>;
  onEditEmployee?: (employeeId: string) => void;
  setSelectedRowIds: (ids: string[]) => void;
  onNetPayChange?: (employeeId: string, netPay: string) => void;
};

export const PayrollDraftTable = ({
  employees,
  selectedRowIds,
  formState,
  onEditEmployee,
  setSelectedRowIds,
  onNetPayChange,
}: PayrollDraftTableProps) => {
  const hasScanEmployee = employees.some((employee) => employee.destination?.type === BeneficiaryType.SCAN);
  const table = useReactTable({
    data: employees,
    columns: payrollDraftTableColumnDefinition,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    initialState: {
      pagination: {
        pageSize: PAGE_SIZE,
      },
    },
    meta: {
      selectedRowIds,
      onEditEmployee,
      setSelectedRowIds,
      formState,
      onNetPayChange,
      showAccountOptions: hasScanEmployee,
    },
  });
  return (
    <Stack space={5} align="stretch" className="pt-5">
      <DataTableNew.Table table={table} aria-label="Employee records table" className="min-w-0" />
      {table.getPageCount() > 1 && (
        <Inline justify="end">
          <DataTableNew.Pagination table={table} />
        </Inline>
      )}
    </Stack>
  );
};
